<template>
  <v-content>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <core-about
      style="margin-top: -5pt"
      v-if="
        $route.name !== 'Login' &&
        $route.name !== 'EntityLink' &&
        $route.name !== 'EntityLinkHighlightedCard' &&
        $route.meta.isFrontend == true &&
        $route.name !== 'ProspectingBuyers' &&
        $route.name !== 'Home' &&
        $route.name !== 'About' &&
        $route.name !== 'GoodCausePublic'
      "
    />
    <core-footer
      v-if="
        $route.name !== 'Login' &&
        $route.name !== 'EntityLink' &&
        $route.name !== 'EntityLinkHighlightedCard' &&
        $route.meta.isFrontend == true &&
        $route.name !== 'ProspectingBuyers'
      "
    />
  </v-content>
</template>

<script>
export default {};
</script>

<style>
#core-view {
  padding-bottom: 0px;
}
.v-content {
  background: white;
}
</style>
